import values from 'lodash/values';

import PGExperiments from '../PGExperiments';
import { Experiments, VariationMap, Variations } from './types';

export { Experiments, Variations };

const getActiveExperiment = (
  experimentName: Experiments
): IOptimizelyExperimentStateObject | undefined => {
  if (!window.optimizely || !window.optimizely.get) {
    return;
  }

  const experimentStates = window.optimizely.get('state').getExperimentStates();

  return values(experimentStates).find(
    (exp) => exp.isActive && exp.experimentName === experimentName
  );
};

export const isVariationActive = <E extends Experiments>(
  experimentName: E,
  variationName: VariationMap[E]
): boolean => {
  if (window.PGExperiments) {
    const experiment = window.PGExperiments.getExperimentByNameAndVariant(
      experimentName,
      variationName
    );

    return experiment.isActive;
  }

  const activeExperiment = getActiveExperiment(experimentName);

  if (!activeExperiment) {
    return false;
  }

  return activeExperiment.variation.name === variationName;
};

export const isMultivariateActive = <E extends Experiments>(
  experimentName: E,
  ...variantNames: VariationMap[E][]
): boolean => variantNames.some((variant) => isVariationActive(experimentName, variant));

export const bucketVisitor = (experimentId: string, variationId: string): void => {
  if (!window.optimizely || !window.optimizely.push) {
    return undefined;
  }

  return window.optimizely.push({
    type: 'bucketVisitor',
    experimentId: experimentId.toString(),
    variationId: variationId.toString(),
  });
};

/* eslint-disable no-console */
export const initPGExperiments = (): void => {
  if (typeof window !== 'undefined') {
    window.PGExperiments = new PGExperiments([
      {
        name: Experiments.COVERAGE_NEEDS_EXPERIMENT_NAME,
        variant: Variations.COVERAGE_NEEDS_VARIANT_NAME,
      }, // CON-2524 - Remove if Coverage Needs loses
      {
        // LIFE-3178 - Remove if Life Onboarding Screen loses
        name: Experiments.LIFE_ONBOARDING_SCREEN_EXPERIMENT_NAME,
        variant: Variations.LIFE_ONBOARDING_SCREEN_VARIANT_NAME,
      },
      {
        // LIFE-3225 - Remove if Feature Brighthouse loses
        name: Experiments.LIFE_FEATURE_BRIGHTHOUSE_EXPERIMENT_NAME,
        variant: Variations.LIFE_FEATURE_BRIGHTHOUSE_VARIANT_NAME,
      },
      {
        // LIFE-3224 - Remove if Funnel Remix loses
        name: Experiments.LIFE_UNDERWRITING_FUNNEL_REMIX_EXPERIMENT_NAME,
        variant: Variations.LIFE_UNDERWRITING_FUNNEL_REMIX_VARIANT_NAME,
      },
      {
        // LIFE-3237 - Remove if Simplified Estimates loses
        name: Experiments.LIFE_SIMPLIFIED_ESTIMATES_EXPERIMENT_NAME,
        variant: Variations.LIFE_SIMPLIFIED_ESTIMATES_VARIANT_NAME,
      },
      {
        name: Experiments.HOUSEHOLD_COMMON_APP_V3_EXPERIMENT_NAME,
        variant: Variations.HOUSEHOLD_COMMON_APP_V3_VARIANT_NAME,
      },
    ]);
    console.log(
      'PGExperiments initialized. Methods: list, activateByIndex(), deactivateByIndex(), getExperimentByNameAndVariant()'
    );
  }
};
/* eslint-enable no-console */
